module.exports = __webpack_public_path__ + "static/media/review-tools-summary.d3c1b637.png";